<template>
  <div style="overflow-y: auto;">
        <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:100vh"
        variant="dark"
        id="loader"
      >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Holding Details Update</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Holding Number/Assessment Id Update for GMC area</span>
          </b-col>
        </b-row>
        <hr/>
        <div style="padding-left:30px;  ">

          <b-row style="padding-top: 10px;">
                <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="12" sm="12" md="3" lg="3"  style="padding-top: 5px;">
                    <b-form-input type="text" maxlength="12" value="" id="consumerNumber" placeholder="Enter your Consumer Number" autocomplete="off" trim required />
                </b-col>
<!-- 
                <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;" >
                <img id="captcha" src="#" alt="captcha">
                <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
              
              </b-col>
              <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                  <b-form-input type="number" id="result" placeholder="Enter the Answer" style="padding-top: 7px;" />
              </b-col> -->

                <b-col col cols="4" sm="3" md="3" lg="1"  style="padding-top: 5px;">
                    <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                      <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                    </b-button>
                </b-col>
              </b-row>
              <!-- <b-row style="padding-top: 10px;">
                  <b-col col cols="12" sm="12" md="8" lg="8" offset-lg="2">
                        <span style="color:red;font-size:0.9rem">* Maximum Five APDCL Connections can be Linked with One Holding Number / Assessment ID</span>
                    </b-col>
              </b-row> -->
        <br>
      <!-- </form> -->

      <div id="UserDetails" class="userDetails marginRight30px" >
        <b-row>
          <b-col cols=12>
              <span class="heading">User Details</span>
          </b-col>
        </b-row>
        <hr/>
        <br>
        <!-- <form id="userRegistration"> -->
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                <span class="label">Consumer Name : </span>
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <span id="consName" ></span>
              </b-col>

            <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
              <span class="label">Connection Type : </span>
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
              <span id="connType" ></span>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Mobile No :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <span id="mobNo" ></span><br>
              <!-- <a href="MobileUpdate" >Click here to Update Mobile No</a> -->
            </b-col>
            <b-col col cols="5" sm="2" md="2" lg="2">
               Subdivision </span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
                <span id="subdivision" ></span>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Property Type :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <b-form-radio-group id="pType" v-model="propertyType">
                <b-form-radio name="propType" value="Owned">Owned</b-form-radio>
                <b-form-radio name="propType" value="Rented">Rented</b-form-radio>
              </b-form-radio-group>
            </b-col>
            <!-- <b-col col cols="5" sm="2" md="4" lg="4">
               Signed Property Tax Money Receipt </span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
                 <input type="file" id="uploadFile"/>
            </b-col> -->
          </b-row>
          <br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Assessment Id <span class="text-danger">*</span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <b-form-input type="text"  id="assessmentId" value="" placeholder="Enter Assessment ID" trim  >
              </b-form-input>
                 <a href="https://gmcpropertytax.com/ptax/Search_Holding_no" target="_blank">Click here to find Assesment ID</a>
              </b-col>
            <b-col col cols="12" sm="12" md="2" lg="2">
            <b-button block squared variant="primary"  id="button"  @click="showHoldingDetails()">
                Verify</b-button>
            </b-col>

          </b-row>


        <!-- </form> -->
      </div>

      </div>
  </b-container>
  <br>


  <b-modal id="holdingDetailsModal" lazy centered no-close-on-esc  no-close-on-backdrop title="Holding Details" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5">
        <span class="label">Assessment ID: </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7">
      <span class="holdingData"> {{assmntId}}</span>
      </b-col>
</b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Holding No : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{holdingNo}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Zone : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{zone}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">House No : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{houseNo}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Location : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{location}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Owner Name : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{owner}}</span>
    </b-col>
  </b-row>

  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Road No : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{roadNo}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Road Name : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{roadName}}</span>
    </b-col>
  </b-row>
  <b-row>
    <b-col col cols="12" sm="12" md="5" lg="5" class="marginTop10px">
      <span class="label">Ward : </span>
    </b-col>
    <b-col col cols="12" sm="12" md="7" lg="7" class="marginTop10px">
      <span class="holdingData">{{ward}}</span>
    </b-col>
  </b-row>
<br>
  <b-row>
    <b-col col cols="12" sm="12" md="6" lg="6" class="marginTop10px">
      <b-button class="btn" variant="primary" id="success-btn" @click="maxFiveHoldingCheck()" style="width:100%" >Update</b-button>
    </b-col>
    <b-col col cols="12" sm="12" md="6" lg="6" class="marginTop10px">
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="closeModal()" style="width:100%">Cancel</b-button>
    </b-col>
  </b-row>


</b-overlay>
  </b-modal>

  <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show2"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
    Enter the OTP received in your mobile number <b> {{ consMobile }} </b>:
    <b-form-input type="number" id="otp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="holdingUpdate()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
  </b-modal>

  <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header>
    <h3>Consumer Holding Details Update</h3>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">Successfully Updated !<br><br>
    <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
    </p>
  </b-modal>

  <b-modal id="successModal2" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header :static="true">

    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success" id="successMsg"></p>
    <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
    </p>
  </b-modal>

  <b-modal id="failureModal" centered scrollable title="Consumer Holding Details Update" hide-footer :static="true">
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <p class="error">Update Failed ! </p>
    <p class="error" id="failMsg"></p>

  </b-modal>
  <b-modal id="failureModal2" centered scrollable title="Consumer Holding Details Update" hide-footer :static="true">
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>

    <p class="error" id="failMsg2"></p>

  </b-modal>

  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg"> </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal1()">OK</b-button>
  </b-modal>

  <b-modal id="holdingModal1" centered  scrollable title="ALERT !" :static="true" hide-footer>
  <br>
    <b-row>
      <b-col col cols="12" sm="12" md="12" lg="12" class="marginTop10px" style="color:red;text-align:center">
      Unable to Fetch Holding Details. <br>
      Kindly Try After Sometime.
      </b-col>

    </b-row>
<br>
    <b-row>

      <b-col col cols="12" sm="12" md="4" lg="4" offset-lg="4"  offset-md="4" class="marginTop10px">
        <b-button class="btn" variant="outline-primary" id="success-btn" @click="closeModal2()" style="width:100%">Close</b-button>
      </b-col>
    </b-row>
  </b-modal>



</b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
var CryptoJS = require("crypto-js");
var consNo="";
var consDetails = [];
var holdingDetails = [];
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        selected: null,
        assmntId :'',
        holdingNo:'',
        zone:'',
        houseNo:'',
        location:'',
        owner:'',
        fatherName:'',
        roadNo:'',
        roadName:'',
        ward:'',
        propertyType :'',
        consMobile :''
    }
  },
  methods: {
    reloadPage()
    {
      window.location.reload();
    },
    generateCaptcha()
    {
      axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                //console.log(response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
    },
    
    // verifyCaptcha()
    // {
    //   var parent = this;
    //   var consNo = document.getElementById("consumerNumber").value;
    //    if ((consNo.toString().length!=12))
    //        {
    //          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
    //            title: `Alert`,
    //            variant: 'danger',
    //            solid: true
    //          })
    //          return;
    //        }
    //   var result = document.getElementById("result").value;
    //   if ((result==""))
    //        {
    //          this.$bvToast.toast('Enter Captcha !', {
    //            title: `Alert`,
    //            variant: 'danger',
    //            solid: true
    //          })
    //          return;
    //        }

    //   axios.post(this.$urlCommon+'/api/web/verifyCaptcha?result='+result)
    //        .then((response) => {
    //         console.log(response.data);
    //         if(response.data=="success")
    //         {
    //           console.log("Captcha verified");
    //           parent.showDetails();
    //         }
    //         else{
    //           parent.$bvToast.toast('Invalid Captcha ! Please try again', {
    //                title: `Alert`,
    //                variant: 'danger',
    //                solid: true
    //              });
    //           return;
    //         }
    //        })

    // },
    showDetails() {
      document.getElementById("consName").innerHTML = "";
      document.getElementById("connType").innerHTML = "";
      document.getElementById("mobNo").innerHTML =  "";
      document.getElementById("subdivision").innerHTML = "";
      document.getElementById("assessmentId").value="";
      consNo= document.getElementById("consumerNumber").value;
      this.consNumber=consNo;

        var parent = this;
 
       if ((consNo.toString().length!=12))
           {
             this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
      // var result = document.getElementById("result").value;
      // if ((result==""))
      //      {
      //        this.$bvToast.toast('Enter Captcha !', {
      //          title: `Alert`,
      //          variant: 'danger',
      //          solid: true
      //        })
      //        return;
      //      }

      

        const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025","030"]
        var sdCode=consNo.substring(0,3);
        console.log("sdCode:::"+sdCode);
        var isGmcCons = sdList.includes(sdCode);
        console.log("isGmcCons:::"+isGmcCons)

        if(!isGmcCons)
        {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Consumer does not belong to GMC area";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
          return;
        }
      var parent=this;
      this.show= true;

      axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
    //    axios.get(this.$urlCommon+'/api/web/holdingDetails/getConsDetails?consNo='+consNo+'&result='+result)
        .then((response) => {
        parent.show= false;
      //  console.log(response.data);
        document.getElementById("UserDetails").classList.add("showUserDetails");
        consDetails = response.data;
        var data=response.data;
        var status = data.message;


        if(status=="00")
        {
          if(data.mobile_no!=null)
            {
              var mobileNo =  response.data.mobile_no.substring(0,2) + "*****" + response.data.mobile_no.substring(7)
              parent.consMobile = mobileNo;
            }
          else{
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="Sorry, Mobile Number not Updated <br> <a href='ConsumerRegistration'>Click Here to Register and Update</a>";
            document.getElementById("UserDetails").classList.remove("showUserDetails");
            console.log("mobile No is NULL###");
            return;
           }
          document.getElementById("consName").innerHTML = data.cons_name;
          document.getElementById("connType").innerHTML = data.connType;
          document.getElementById("mobNo").innerHTML =  parent.consMobile;
          document.getElementById("subdivision").innerHTML = data.subDivisionName;

        }
        else if(status=="captcha_incorrect"){
          parent.$bvToast.toast('Invalid Captcha ! Please try again', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
              document.getElementById("UserDetails").classList.remove("showUserDetails");
              this.generateCaptcha();
              return;
        }
        else
        {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
        }

      })
      .catch((e) => {
      console.log("Caught", e);
      this.show= false;
    })

  },

showHoldingDetails()
{
  var parent =this;
  var assessmentId = document.getElementById("assessmentId").value;
  if(this.propertyType=="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Select Property Type !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

      return
      }

    /*  var file = document.querySelector('#uploadFile');
      console.log(file.files[0]);
      if(file.files[0]==undefined)
          {
            // document.getElementById('failure-btn-mob').click();
            this.$bvToast.toast('Please Select File to Upload !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
              document.getElementById("uploadFile").focus();
          return
          }
          */
  if(assessmentId=="")
      {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Please Enter Assessment ID !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
          document.getElementById("assessmentId").focus();
          return
      }

  parent.show= true;
  axios.post("https://gmcpropertytax.com/ptax/api/AssessmentController/get_assessment_record?AssessmentKey="+assessmentId).then(function(response) {
    console.log(response.data);
    parent.show= false;
    if(Object.keys(response.data).length===0)
    {
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML="Sorry, Assessment Id Not Found";
    return;
    }
    else if(response.data==="Assessment Info Error")
    {
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML=response.data;
    return;
    }
    else {
      holdingDetails = response.data;
      var data=response.data;

      parent.$bvModal.show('holdingDetailsModal');
      parent.assmntId = data.AssessmentKey;
      parent.holdingNo = data.HoldingNo;
      parent.zone = data.Zone;
      parent.houseNo = data.HouseNo;
      parent.location = data.LocationName;
      parent.owner = data.OwnerName;
      parent.roadNo = data.RoadNo;
      parent.roadName = data.RoadName;
      parent.ward = data.Ward;

    }
  })
  .catch((e) => {

    parent.assmntId = assessmentId;
    parent.holdingNo = "GMC API Error";
    parent.show= false;
    parent.$bvModal.show('holdingModal1');
    console.log("Caught :::::::::::::::", e.message);
  });
},

closeModal(){
  this.$bvModal.hide('holdingDetailsModal');
},
closeModal1(){
  this.$bvModal.hide('model');
},

closeModal2(){
  this.$bvModal.hide('holdingModal1');
},
sendOtp()
{
  var parent =this;
  var mobile = consDetails.mobile_no;


  parent.$bvModal.show('otpModal');

  parent.show1= true;
  axios.post(this.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
    console.log(response.data);
    parent.show1= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
      parent.$bvModal.show('otpModal');

    }
    else {
      parent.$bvToast.toast('OTP Generation Failed !', {
        title: `Failed`,
        variant: 'danger',
        solid: true
      });
    }
  });

},

resendOtp()
{
  var parent =this;
    var mobile = consDetails.mobile_no;
  parent.show2= true;

  axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
    parent.show2= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    }
  else {
      parent.$bvToast.toast('OTP Generation Failed !', {
        title: `Failed`,
        variant: 'danger',
        solid: true
      });
    }
  });

},
maxFiveHoldingCheck()
{
  var holdingNo = this.holdingNo;
  var parent=this;
   parent.show= true;
  axios.get(this.$urlCommon+'/api/web/checkHoldingNoMaxFive?holdingNo='+holdingNo)
   .then((response) => {
   parent.show= false;
   console.log(response.data);
   if(response.data.status == "success")
   {
     if( parseInt(response.data.counter) < 5)
       {
         parent.sendOtp();
       }
     else {
         parent.$bvModal.show('failureModal2');
         document.getElementById("failMsg2").innerHTML="Holding Number / Assessment ID already linked with five APDCL connections";
       }
   }
   else {
       parent.$bvModal.show('failureModal');
       document.getElementById("failMsg").innerHTML="Holding Number Update Failed. Please Try Again.";
     }

 })
},
duplicateHoldingCheck()
{
  var holdingNo = this.holdingNo;
  var parent=this;
   parent.show= true;
  axios.post(this.$urlCommon+'/api/web/checkHoldingNo?holdingNo='+holdingNo)
   .then((response) => {
   parent.show= false;
   console.log(response.data);
   if(response.data.data == "NotFound")
   {
     parent.sendOtp();
   }
   else {
     parent.$bvModal.show('failureModal');
     document.getElementById("failMsg").innerHTML="Holding Number Already Registered";

   }

 })
},
holdingUpdate(){

      var otp = document.getElementById("otp").value;
      var mobile = consDetails.mobile_no;
      var parent =this;
      parent.show2= true;


            var parent2=parent;

            var dataToSend = JSON.stringify({
              "cons_no": consDetails.cons_no,
              "cons_name": consDetails.cons_name,
              "subdivision": consDetails.subDivisionName,
              "category": consDetails.category_CODE+"-"+consDetails.category_NAME,
              "connection_type": consDetails.connType,
              "mobile": consDetails.mobile_no,
              "property_type":  parent2.propertyType,

              "assessment_key": parent.assmntId,
              "holding_no":   parent.holdingNo,
              "zone": holdingDetails.Zone,
              "house_no": holdingDetails.HouseNo,
              "location": holdingDetails.LocationName,
              "owner_name": holdingDetails.OwnerName,
              "father_name": holdingDetails.FathersName,
              "building_usage": holdingDetails.BuildingUsage,
              "qtax_paid_upto": holdingDetails.QtaxPaidUpto,
              "date_of_assesment": holdingDetails.DateOfAssessment,
              "road_no": holdingDetails.RoadNo,
              "road_name": holdingDetails.RoadName,
              "ward": holdingDetails.Ward,
              "uploaded_doc":"NA",
              "source":"website"
            });

              var parent3=parent2;

              var config = {
                method: 'post',
                url: parent2.$urlCommon+"/api/web/UpdateHoldingDetailsOTP?mobNo="+mobile+"&otp="+otp,
                headers: {
                  'Content-Type': 'application/json'
                },
                data : dataToSend
              };

              axios(config)
              .then(function (response) {
                parent3.show2= false;
              console.log(response.data);
                if(response.data.status=="success")
                {
                  parent3.$bvModal.show('successModal');

                  // var data2push = response.data.dataToPush;
                  // var dataToPush = JSON.stringify({
                  //    "SUB_DIV":data2push.sub_DIV,
                  //    "CONS_NO":data2push.cons_NO,
                  //    "CONS_NAME":data2push.cons_NAME,
                  //    "CONS_ADDRESS":data2push.cons_ADDRESS,
                  //    "CONS_ADDRESS_2":data2push.cons_ADDRESS_2,
                  //    "CONS_PHONE_NO":data2push.cons_PHONE_NO,
                  //    "CATEGORY":data2push.category,
                  //    "LATITUDE":data2push.latitude,
                  //    "LONGITUDE":data2push.longitude,
                  //    "HOLDING_NO":data2push.holding_NO
                  //     })
                  //     console.log(dataToPush);
                  //     var config2 = {
                  //       method: 'post',
                  //       url: "https://gmcpropertytax.com/ptax/api/ApdclApiController/insertApdclData",
                  //       headers: {
                  //         'Content-Type': 'application/json'
                  //       },
                  //       data : dataToPush
                  //     };
                  //     axios(config2)
                  //     .then(function (response) {
                  //           console.log(response.data);
                  //     })

                }
                else if(response.data.status=="failure") {
                  parent3.$bvModal.show('failureModal');

                }
                else if(response.data.status=="exist") {
                  parent3.$bvModal.show('successModal2');
                  document.getElementById("successMsg").innerHTML=response.data.msg;
                }
                else {
                  parent.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML="Invalid OTP";
                }
              })
              .catch(function (error) {
                console.log(error);
                  var parent=this;
                  parent3.$bvModal.show('failureModal');
              });
    },

holdingUpdateWithFile(){
      if(document.getElementById('uploadFile').files[0].size/1024/1024 > 1)
      {
        this.$bvToast.toast('File size must be less than 1 Mb !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }

      var formData = new FormData();
      var file = document.querySelector('#uploadFile');
      formData.append("consNo", consDetails.cons_no );
      formData.append("uploadfile", file.files[0]);
      console.log(formData)
      var otp = document.getElementById("otp").value;
      var mobile = consDetails.mobile_no;
      var parent =this;
      parent.show2= true;
    //  axios.post(this.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response) {

//        if (response.data.message == "VALID")

          if(1){

            parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });

        var parent2=parent;
        axios.post(parent2.$urlCommon + "/api/web/uploadHoldingFile", formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response){
          console.log(response.data)
          if(response.data.status="success")
          {
            var dataToSend = JSON.stringify({
              "cons_no": consDetails.cons_no,
              "cons_name": consDetails.cons_name,
              "subdivision": consDetails.subDivisionName,
              "category": consDetails.category_CODE+"-"+consDetails.category_NAME,
              "connection_type": consDetails.connType,
              "mobile": consDetails.mobile_no,
              "property_type":  parent2.propertyType,
              "assessment_key": holdingDetails.AssessmentKey,
              "holding_no": holdingDetails.HoldingNo,
              "zone": holdingDetails.Zone,
              "house_no": holdingDetails.HouseNo,
              "location": holdingDetails.LocationName,
              "owner_name": holdingDetails.OwnerName,
              "father_name": holdingDetails.FathersName,
              "building_usage": holdingDetails.BuildingUsage,
              "qtax_paid_upto": holdingDetails.QtaxPaidUpto,
              "date_of_assesment": holdingDetails.DateOfAssessment,
              "road_no": holdingDetails.RoadNo,
              "road_name": holdingDetails.RoadName,
              "ward": holdingDetails.Ward,
              "uploaded_doc":response.data.filePath,
              "source":"website"
            });

              var parent3=parent2;

              var config = {
                method: 'post',
                url: parent2.$urlCommon+'/api/web/UpdateHoldingDetails',
                headers: {
                  'Content-Type': 'application/json'
                },
                data : dataToSend
              };

              axios(config)
              .then(function (response) {
                parent3.show2= false;
                console.log(JSON.stringify(response.data));
                if(response.data=="success")
                {
                  parent3.$bvModal.show('successModal');
                }
                else {
                  parent3.$bvModal.show('failureModal');
                }
              })
              .catch(function (error) {
                console.log(error);
                  var parent=this;
                  parent3.$bvModal.show('failureModal');
              });

          }
          else {
            parent2.$bvModal.show('failureModal');
          }

        })



      }
      else{
        parent.show2= false;
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML="Invalid OTP";
      }
    //    })

    },

  },
  mounted()
  {
    // axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
    //             document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    // })
  }
}
</script>

<style scoped="true">
.label{
text-align:left
}
.data{
  font-weight: 500;
  color: #e64a19      ;
  font-size: 1.1rem;
}
.holdingData{
  font-weight: 500;
  color: black;
  font-size: 1rem;
}
.userDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
}
.showUserDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>
